import { render, staticRenderFns } from "./SkipFraudOrders.vue?vue&type=template&id=4b06c94e&"
import script from "./SkipFraudOrders.vue?vue&type=script&lang=js&"
export * from "./SkipFraudOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports